import { Component, Input } from '@angular/core';
import { Stream } from '../../models/Stream';
import { ModalController } from 'ionic-angular';
import { AddStreamComponent } from '../add-stream/add-stream';
import { Subscription } from 'rxjs';
import { UserProvider } from '../../providers/user/user';

@Component({
    selector: 'stream-view',
    templateUrl: 'stream-view.html'
})
export class StreamViewComponent {

    @Input('stream') stream: Stream;
  
    isAdmin = false;
    subscription: Subscription;

    constructor(public modalCtrl: ModalController, public userCtrl: UserProvider) {
      this.subscription = this.userCtrl.isAdmin().subscribe(isAdmin => {this.isAdmin = isAdmin});

    }

    ngOnDestroy(){
      this.subscription.unsubscribe();
    }

    open() {
      if(this.isAdmin){
        let modal = this.modalCtrl.create(AddStreamComponent, { stream: this.stream });
        modal.present();
      }
  }

}



// WEBPACK FOOTER //
// ./src/components/stream-view/stream-view.ts